import { render, staticRenderFns } from "./ShareBlockDialog.vue?vue&type=template&id=11281051"
import script from "./ShareBlockDialog.vue?vue&type=script&lang=js"
export * from "./ShareBlockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports